module.exports = __webpack_public_path__ + "img/cju_gallery2.bfa8a570.jpg";